import React, { Component } from "react";
import { Alert, Divider, Modal, message, Spin } from "antd";
import { connect } from "dva";
import DownloadFile from "nbugs-pc-downloadfile";
import styles from "./index.less";
import RarIcon from "../../../../../../assets/fileUpload/fileIcon/rar.png";
import ZipIcon from "../../../../../../assets/fileUpload/fileIcon/zip.png";
import { GetQueryString } from "../../../../../../utils/utils";
import { url } from "../../../services/service-utils";

const fileData = [
  {
    icon: ZipIcon,
    fileName: "自评上传附件及自评报告汇总.zip",
    type: "selfAll"
  },
  {
    icon: RarIcon,
    fileName: "自评指标内容汇总.rar",
    downLoadUrl: `${url.url}/project/statistics/self/download`
  },
  {
    icon: ZipIcon,
    fileName: "网评上传附件汇总.zip",
    type: "evaluationAll"
  },
  {
    icon: RarIcon,
    fileName: "网评指标内容汇总.rar",
    downLoadUrl: `${url.url}/project/statistics/other/download`
  }
];

@connect(({ projectStatistics }) => ({
  ...projectStatistics
}))
class index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      nowGroupIds: [],
      nowZipName: "",
      startDownload: false,
      nowModalType: "selfAll"
    };
    this.projectId = GetQueryString("currentProjectId");
  }

  // 展示报告列表
  handleShowFileList = type => {
    const { dispatch } = this.props;
    this.setState({
      showModal: true,
      nowModalType: type
    });
    dispatch({
      type:
        type === "selfAll"
          ? "projectStatistics/fetchSelfFileList"
          : "projectStatistics/fetchEvaluationFileList",
      payload: {
        projectId: this.projectId
      }
    });
  };

  // 关闭对话框
  handleCancelModal = () => {
    this.setState({
      showModal: false,
      startDownload: false,
      nowZipName: "",
      nowGroupIds: []
    });
  };

  // 通过下载组件下载文件(modal里的下载)
  handleDownFileList = data => {
    const { appendixList, orgName } = data;
    const { nowModalType } = this.state;
    this.setState({
      nowZipName: `${orgName}-${
        nowModalType === "selfAll" ? "自评" : "网评"
      }报告附件汇总`,
      nowGroupIds: appendixList,
      startDownload: true
    });
  };

  // 组件下载完成时的回调
  handleDownloadFileFinish = () => {
    message.success("下载成功");
    this.setState({
      startDownload: false,
      nowZipName: "",
      nowGroupIds: []
    });
  };

  // 渲染每个学校的下载
  renderFileItem = () => {
    const { fileList } = this.props;
    return fileList?.length ? (
      fileList.map(item => {
        return (
          <div className="fileWrapper">
            <div className="fileContainer">
              <div className="icon">
                <img src={ZipIcon} alt="" />
              </div>
              <div className="fileName">{item.orgName}</div>
            </div>
            <div className="fileDownload">
              <span onClick={() => this.handleDownFileList(item)}>下载</span>
            </div>
          </div>
        );
      })
    ) : (
      <div className="modalNoData">暂无数据</div>
    );
  };

  render() {
    const { showModal, nowGroupIds, nowZipName, startDownload } = this.state;
    const { spinProps } = this.props;

    const alertProps = {
      description: "使用说明：以下为参与本次项目的上传文件汇总情况。",
      type: "info",
      showIcon: true,
      closable: true
    };

    const modalProps = {
      visible: showModal,
      title: "查看下载列表",
      footer: null,
      wrapClassName: styles.projectStatisticsModalWrapper,
      onCancel: this.handleCancelModal,
      zIndex: 998
    };

    const downLoadFileProps = {
      groupIds: nowGroupIds,
      startDownload,
      isFinish: this.handleDownloadFileFinish,
      zipName: nowZipName
    };

    return (
      <div className={styles.root}>
        <Alert {...alertProps} />
        <Divider orientation="left">附件</Divider>
        {fileData.map(item => {
          return (
            <div className="fileWrapper">
              <div className="fileContainer">
                <div className="icon">
                  <img src={item.icon} alt="" />
                </div>
                <div className="fileName">{item.fileName}</div>
              </div>
              <div className="fileDownload">
                {item.type === "selfAll" || item.type === "evaluationAll" ? (
                  <span onClick={() => this.handleShowFileList(item.type)}>
                    查看下载列表
                  </span>
                ) : (
                  <a
                    href={`${item.downLoadUrl}?projectId=${this.projectId}`}
                    download
                  >
                    下载
                  </a>
                )}
              </div>
            </div>
          );
        })}
        {showModal && (
          <Modal {...modalProps}>
            <Spin {...spinProps}>{this.renderFileItem()}</Spin>
          </Modal>
        )}
        <DownloadFile {...downLoadFileProps} />
      </div>
    );
  }
}

export default index;
